<template>
<div class="chapter">
<div class="inner_page">
<p class="indent"><a id="file_017">To make ends meet, the company repaired mangled Loenings. The first airframe they dragged home nearly did them as much harm as good. The boys bought the crashed plane from an insurance company and towed it to Baldwin behind Grumman’s Hudson automobile. The nose of the soon-to-be-repaired plane stuck out into the street. In the winter darkness, a passing motorist smashed into the plane. Grumman calmed the angry driver by telling him he had all the tools, manpower, and know-how to fix the automobile in his shop, and for a time the crunched car sat beside the injured plane, awaiting overhaul.</a></p><a id="file_017">
<p class="indent">Another job was much more profitable. The crew acquired a wrecked Loening Commuter on Lake Champlain for $450. After a lot of hard work, the repaired plane sold for $20,000. The resurrected wrecks, along with some aluminum truck bodies and floats for U.S. Navy planes, kept Grumman in the black even during that bleak first year. They made $5,500 profit.</p>
<p class="indent">It wasn’t enough to keep the company’s senior-most executive officers off the streets, so to speak, scouring the gutters for discarded treasures. Wouldn’t it be the supreme irony if Grumman or Swirbul was run down by a truck they’d recently helped build?</p>
<p class="indent">Grumman’s profit came at a price during that first year. Besides getting raw materials wherever they could find them, company leaders sometimes had to skip paying their employees for a week.</p>
</a><p class="indent"><a id="file_017">When Grumman operated an airplane, the company insured the machine only for the hours it was actively test flying. And then everyone prayed that </a><a id="page_12">there wouldn’t be a fire where the fueled aircraft was parked during the night.</a></p><a id="page_12">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_017.vue?1302da10